import React from 'react';

interface CrmGridSkeletonProps {
  cards?: number;
}

export const CrmGridSkeleton: React.FC<CrmGridSkeletonProps> = ({ cards = 6 }) => (
  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
    {Array.from({ length: cards }).map((_, i) => (
      <div key={i} className="animate-pulse rounded-xl border border-border bg-surface p-4">
        <div className="h-5 w-3/4 rounded bg-border" />
        <div className="mt-2 h-3 w-1/2 rounded bg-border" />
        <div className="mt-4 h-16 w-full rounded-lg bg-border" />
        <div className="mt-3 h-3 w-full rounded bg-border" />
      </div>
    ))}
  </div>
);
